import { render, staticRenderFns } from "./CapitalDistributionTip.vue?vue&type=template&id=233b3732&scoped=true"
import script from "./CapitalDistributionTip.vue?vue&type=script&lang=js"
export * from "./CapitalDistributionTip.vue?vue&type=script&lang=js"
import style0 from "./CapitalDistributionTip.vue?vue&type=style&index=0&id=233b3732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b3732",
  null
  
)

export default component.exports